import axiosInstance, { API_ROUTES } from '../lib/http/httpRequest';
import { AxiosResponse } from 'axios';
import { GlobalUnlockData } from '@/state/general/generalTypes';
import { ClientStorageResponse } from '@/state/clientStorage/clientStorageTypes';

export const getGlobalUnlockData = (): Promise<AxiosResponse<GlobalUnlockData>> =>
    axiosInstance.get(API_ROUTES.GLOBAL_UNLOCKED);

export const getClientStorage = (): Promise<AxiosResponse<ClientStorageResponse>> =>
    axiosInstance.get(`${API_ROUTES.CLIENT_STORAGE}`);

export const setClientStorage = (payload: any): Promise<AxiosResponse<any>> =>
    axiosInstance.post(`${API_ROUTES.CLIENT_STORAGE}`, payload);
